import TabToggle from 'components/commons/tab-toogle'
import { InlineError, Input } from 'avo-ui'
import MultipleSelect from 'components/commons/multiple-select'

export const ProductHighlight = ({ brandDetail, onSearchProduct, optionsProduct, onChangeForm, errorForm }) => {
    return (
        <TabToggle
            title={'Product Highlight'}
            content={
                <div className={'flex flex-col w-1/2 space-y-5'}>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90'}>Title Promo</div>
                        <Input
                            className={'flex-1'}
                            name={'promotion_title'}
                            placeholder={'Masukkan title promo'}
                            value={brandDetail?.promotion_title}
                            onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.promotion_title} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90'}>Pilih Produk</div>
                        <MultipleSelect
                            name={'promotion_product_ids'}
                            placeholder={'Search Product...'}
                            onSearch={onSearchProduct}
                            value={brandDetail?.promotion_product_ids}
                            options={optionsProduct}
                            onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.promotion_product_ids} />
                    </div>
                </div>
            }
        />
    )
}
